import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicFormControl } from '@shared/modules/dynamic-forms/dynamyc-form.d.model';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  @Input()
  public formFields: DynamicFormControl<string | boolean>[];

  @Output()
  public formSubmit: EventEmitter<FormGroup> = new EventEmitter();

  public form: FormGroup;

  ngOnInit() {
    const formFields = {};
    this.formFields.forEach(field =>
      formFields[field.key] = new FormControl(field.value, field.validators));
    this.form = new FormGroup(formFields);
  }

  submit() {
    this.formSubmit.emit(this.form);
  }

}
